export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || 'https://ropera-edu.com';
export const DESKTOP_APP_DOWNLOAD_URL = process.env.REACT_APP_DESKTOP_APP_DOWNLOAD_URL || 'https://ropera-edu.com/downloads/ropera-virtual-setup.exe';

export const SESSION_RESOURCE_LINKS = [
  WEBSITE_URL,
  'https://perla-tech.com',
  'https://google.com',
];
